import { render, staticRenderFns } from "./Subheader.vue?vue&type=template&id=4a0f75a6&scoped=true&"
import script from "./Subheader.vue?vue&type=script&lang=ts&"
export * from "./Subheader.vue?vue&type=script&lang=ts&"
import style0 from "./Subheader.vue?vue&type=style&index=0&id=4a0f75a6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a0f75a6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VIcon,VImg,VRow,VSpacer})
